export default __webpack_public_path__ + "media/images/facebook-image-a9872ef04ea4427f0099425761dd14bd.jpg";